import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class ConditionalReuseStrategy implements RouteReuseStrategy {
    shouldDetach(route: ActivatedRouteSnapshot): boolean { return false; }
    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void { }
    shouldAttach(route: ActivatedRouteSnapshot): boolean { return false; }
    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null { return null; }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        if (!curr || !future) return false;

        const path = future.routeConfig?.path;
        if (path === ':id/create') {
            const sameId = future.params['id'] === curr.params['id'];
            return sameId;
        }

        return future.routeConfig === curr.routeConfig;
    }
}